import React from 'react';
import Reveal from 'react-reveal/Reveal';
import styles from './animation.scss';

export default function Animation(props) {
	let passedStyle = styles['fade-in-up'];
	if(props.className){
		passedStyle = props.className;
	}
	return (
		<Reveal effect={passedStyle}>
			{props.children}
		</Reveal>
	)	
}
